export const ACTIVITY_LOG_LOADED = "activityLog/loaded"
export const ACTIVITY_LOG_ENTRIES_ADDED = "activityLog/entriesAdded"

export const ACTIVITY_LOG_ENTRY_ADDED = "activityLog/added"